/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MaxDocumentUpdateSizeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MAX_DOCUMENT_UPDATE_SIZE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class MaxDocumentUpdateSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MaxDocumentUpdateSizeSettingParser.decode(input).map(res => new MaxDocumentUpdateSizeSetting(res));
    }
    static unsafeDecode(input) {
        return MaxDocumentUpdateSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MaxDocumentUpdateSizeSettingParser.encode(data);
    }
    static schema() {
        return MaxDocumentUpdateSizeSettingParser.schema();
    }
}
